import { IRunOptions, Paragraph, Run } from 'docx';
import { toast } from 'react-toastify';

export const createRun = (text, isBold, options?: IRunOptions, fontSize?) => {
  return new Run({
    text,
    color: '000000',
    bold: isBold,
    font: 'Arial',
    size: fontSize || 24,
    ...options,
  });
};

export const createParagraph = (
  children,
  heading,
  spacing = { before: 200 },
  pageBreakBefore = false,
) => {
  return new Paragraph({
    children,
    heading,
    pageBreakBefore,
    spacing: {
      before: spacing.before,
    },
  });
};

export const showToast = (
  message: string,
  containerId = 'universalToastContainer',
) =>
  toast(message, {
    containerId,
  });

export const delay = (ms = 10) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const getLocalStorageItem = (key: string, defaultValue = ''): string => {
  return typeof window !== 'undefined'
    ? localStorage.getItem(key) || defaultValue
    : defaultValue;
};
